import React, { useEffect, useState } from 'react'
import Player from '~/components/calls/show/Player'
import TelemarketingCustomData from '~/components/calls/show/TelemarketingCustomData'
import withWebsocket, { WithWebsocketProps } from '~/decorators/withWebsocket'
import { CallBoth } from '~/service/SipConn'
import Describe from '../../calls/show/Describe'
import { SubmitForm } from '../../calls/show/Describe/types'
import ClientHeader from '../../common/ClientHeader'
import { Tab } from '../Call'
import Avatar from './Avatar'
import { CustomLink } from '~/components/common/CustomLink'

type Props = {
  call: CallBoth
  status: JSX.Element
  tab: Tab | undefined
  setStartSubmit: React.Dispatch<React.SetStateAction<boolean>>
  submitRef: React.MutableRefObject<SubmitForm | undefined>
  onEndClick: () => Promise<void>
}

type ApiDataType = {}

const Data: React.FC<Props & WithWebsocketProps<ApiDataType>> = ({
  call,
  status,
  tab,
  setStartSubmit,
  submitRef,
  channel,
  onEndClick,
}) => {
  const [recording, setRecording] = useState<string>()

  const client = call.client!
  const data = call.apiData!

  useEffect(() => {
    channel.on('recording', ({ recording }) => {
      setRecording(recording)
    })
  }, [])

  return (
    <>
      <div className="phone-call-top">
        <Avatar call={call} />

        <ClientHeader
          call={data}
          client={client}
          showAvatar={false}
          showPresence={false}
          nameAsLink={!window.c.itsm}
        />

        <CustomLinks links={data.customLinks} />

        {data.ivr && <div className="phone-call-top-ivr">{data.ivr}</div>}

        {status}
      </div>

      {recording && (
        <div className="phone-call-details call-show-details">
          <div className="call-show-details-player">
            <Player recording={recording} />
          </div>
        </div>
      )}

      {data.tmContact?.customData && (
        <div className="phone-call-tmCustomData">
          <TelemarketingCustomData call={data} />
        </div>
      )}

      {call.establishedAt && tab == 'describe' && (
        <div className="phone-call-describe">
          <Describe
            submitRef={submitRef}
            call={data}
            duringCall={!call.terminatedAt}
            inPhone={true}
            onStartSubmit={() => {
              setStartSubmit(true)
            }}
            onDescribed={onEndClick}
          />
        </div>
      )}
    </>
  )
}

const DataWithWebsocket = withWebsocket<
  ApiDataType,
  WithWebsocketProps<ApiDataType>,
  Props
>(Data, (_params, props) => 'phone_call:' + props.call.apiData?.id)

export default DataWithWebsocket

type CustomLinksProps = {
  links: CustomLink[]
}

const CustomLinks: React.FC<CustomLinksProps> = ({ links }) => {
  if (!links) {
    return null
  }

  return (
    <>
      {links.map((link, key) => (
        <div key={key}>
          <CustomLink link={link} className="button is-ghost" />
        </div>
      ))}
    </>
  )
}
